import React from 'react';
import Footer from '../../component/Footer';
import HeaderHome from '../../component/HeaderHome';
import trainingBanner from '../../../src/assets/img/Services/Banner image for clinical service for the website (6).png'
import TrainingImg from '../../../src/assets/img/Services/Frame 8480 (4).png'
import patternImg1 from '../../../src/assets/img/Services/red-swirl (8).png'

function Trainings() {

  return (
    <div className='bg-[#F9F9FA] overflow-x-hidden'>
      <HeaderHome />
         <div className="relative mt-8">
  <img
    className="w-full min-h-[298px] bottom-0 object-cover z-0 pointer-events-none"
    src={trainingBanner}
    alt="Vacancy Background"
  />

<div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4">
  <h1 className="text-center tracking-wider font-oregon_black  font-medium text-[28px] sm:text-[30px] md:text-[30px] lg:text-[30px] leading-tight">
    Trainings
  </h1>

  <p className="mt-4 sm:mt-6 tracking-wider font-oregon_black font-medium text-center sm:text-left text-[18px] sm:text-[20px] md:text-[24px] lg:text-[30px] leading-snug sm:leading-normal max-w-[90%] sm:max-w-3xl lg:max-w-5xl">
    Innovative Services and Solutions for a Healthier Tomorrow
  </p>
</div>
</div>
      <div className="mt-16 mx-auto px-4 lg:px-[50px] justify-center w-full h-full">
        <div className="w-full">
          <div className='my-[50px]  mx-auto  flex flex-col lg:grid lg:grid-cols-[56%_44%]  gap-x-10 w-full'>
            <div>
               <h3 data-aos="fade-up" className="mt-12 font-oregon text-[36px] text-[#323B4B] mb-2"><span className="">Trainings</span></h3>
               <ul className='list-disc px-6'>
                  <li data-aos="zoom-in" className="font-corpo text-[20px] text-[#0F172A] leading-[35px] mt-12">At RHC 360 Solutions, we believe that every individual deserves access to high-quality healthcare services that prioritise their well-being, independence, and overall quality of life. As a trusted provider of healthcare services, we are committed to offering a range of specialised care services that cater to the diverse needs of our clients.</li>
          <li data-aos="zoom-in" className="font-corpo text-[20px] text-[#0F172A] leading-[35px]">Our team of skilled and compassionate healthcare professionals are dedicated to delivering exceptional care that is tailored to the unique needs of each individual. We take pride in offering bespoke care packages that are designed to promote independence and enhance the overall quality of life of our clients. What sets us apart from other healthcare providers is our unwavering commitment to putting our clients first, every time.</li>
               </ul>
         
          <div data-aos="zoom-in" className='mt-12 flex justify-center mb-6 lg:mb-0'>
            <a href="/ContactUs" target="blank" className="bg-[#0082DA] text-[20px] text-white  font-corpo py-2 px-5 lg:py-3 lg:px-6 rounded-[10px]">Book Appointment</a>
          </div>
            </div>
            
                           <div className="relative w-full max-w-5xl mx-auto overflow-hidden">
  {/* Background Pattern */}
  <img
    src={patternImg1}
    alt="patternImage"
    className="
      absolute
      inset-0
      w-full
      h-full
      object-cover
      z-0
      pointer-events-none
    "
  />

  {/* Foreground Image */}
  <img
      src={TrainingImg}
      alt="TrainingImage"
      className="relative z-10 object-cover pointer-events-none mt-16 md:mt-32 lg:mt-28 w-full max-w-[90%] sm:max-w-[650px] mx-auto"
    />
</div>
          </div>
         
         
        </div>
      </div>
     
      <Footer />
    </div>
  );
}

export default Trainings;
